import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'

// import { scan } from 'react-scan'

import { initServiceWorker } from '@/lib/sw-worker/init-service-worker.ts'
import { router } from '@/router.ts'

import '@/lib/sentry/sentry-init.ts'
import './index.css'

// scan({ enabled: true })

initServiceWorker()

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  )
}
